<template>
    <div>
  
    <section>
        <div class="project">
             <div class="project-header">
                 <div >
                        <h1 class="project-title">My skills and projects</h1>
                 </div>
                 <div >
                    <ul class="project-nav">

                        <li class="project-nav-item web" v-on:click=" showWebProject ">
                            <div class="project-nav-item-icon">
                                <img src="@/assets/icons8-web-design-64.png" alt="" srcset="">
                            </div>
                            <div class="project-nav-item-name">
                                <p>Web</p>
                            </div>
                        </li>
                        <li class="project-nav-item android" v-on:click="showAndroidProject">
                            <div class="project-nav-item-icon">
                                <img src="@/assets/icons8-android-os-50.png" alt="" srcset="">
                            </div>
                            <div class="project-nav-item-name">
                                
                                <p>Android</p>
                            </div>
                        </li>
                        
                    </ul>
                 </div>
             </div>
             <div v-if=" webOn" >
                   <webProjects></webProjects>
               
             </div>
            <div v-if="androidOn" >
                   <androidProjects></androidProjects>
            
             </div>
        </div>
    </section>
    </div>
</template>
<script>

import androidProjects from './AndroidProjects';
import webProjects from './WebProjects';

export default {
    components: {androidProjects,webProjects },
    
      
  data() {
    return {
      
      webOn:true,
      androidOn:false,
     
    };
  },
  
  
  methods: {
      showAndroidProject(){
        
          this.androidOn=true
          this.webOn=false
      },
            showWebProject(){
          this.androidOn=false
          this.webOn=true
      },

    

  }
}
</script>
<style lang="css">

</style>